"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initI18n = undefined;

var _i18next = require("i18next");

var _i18next2 = _interopRequireDefault(_i18next);

var _reactI18next = require("react-i18next");

var _i18nextChainedBackend = require("i18next-chained-backend");

var _i18nextChainedBackend2 = _interopRequireDefault(_i18nextChainedBackend);

var _i18nextResourcesToBackend = require("i18next-resources-to-backend");

var _i18nextResourcesToBackend2 = _interopRequireDefault(_i18nextResourcesToBackend);

var _i18nextHttpBackend = require("i18next-http-backend");

var _i18nextHttpBackend2 = _interopRequireDefault(_i18nextHttpBackend);

var _jsCookie = require("js-cookie");

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var supportedLocales = ["nl_NL", "en_US"];

var namespaces = {
    default: "local-default",
    serverDefault: "server-default",
    whitelabel: "local-whitelabel",
    serverWhitelabel: "server-whitelabel"
};

var getTranslation = function getTranslation(whitelabel, language, namespace, callback) {
    if (language === "dev") {
        callback(null, {});
    } else {
        // Find locale and default to English
        var locale = supportedLocales.find(function (locale) {
            return locale === language;
        }) === undefined ? "en_US" : language;

        if (namespace.startsWith("server")) {
            var type = namespace.endsWith("whitelabel") ? "translations-custom" : "translations";

            // Fetch from server
            fetch("/api/locale/" + type + "/" + locale).then(function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
                    var json;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                                case 0:
                                    if (!(response && response.status === 200)) {
                                        _context.next = 9;
                                        break;
                                    }

                                    json = response.json();
                                    _context.t0 = callback;
                                    _context.next = 5;
                                    return json;

                                case 5:
                                    _context.t1 = _context.sent;
                                    (0, _context.t0)(null, _context.t1);
                                    _context.next = 10;
                                    break;

                                case 9:
                                    callback(null, null);

                                case 10:
                                case "end":
                                    return _context.stop();
                            }
                        }
                    }, _callee, undefined);
                }));

                return function (_x) {
                    return _ref.apply(this, arguments);
                };
            }(), function (error) {
                callback(error, null);
            }).catch(function (error) {
                callback(error, null);
            });
        } else {
            var file = namespace === namespaces.default ? "default" : whitelabel;

            // Fetch locally
            import("./src/locales/" + locale + "/" + file + ".json").then(function (_ref2) {
                var resources = _ref2.default;

                callback(null, resources);
            }).catch(function (error) {
                callback(error, null);
            });
        }
    }
};

var initI18n = exports.initI18n = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(whitelabel) {
        var isCms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var cookieLanguage, language;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        cookieLanguage = isCms ? _jsCookie2.default.get("userLocale") : _jsCookie2.default.get("locale");
                        language = !cookieLanguage || cookieLanguage === "" ? "nl_NL" : cookieLanguage;
                        _context2.next = 4;
                        return _i18next2.default.use(_i18nextChainedBackend2.default).use(_reactI18next.initReactI18next).init({
                            fallbackLng: "nl_NL",
                            lng: language,
                            defaultNS: namespaces.serverWhitelabel,
                            ns: [namespaces.serverWhitelabel, namespaces.serverDefault, namespaces.whitelabel, namespaces.default],
                            fallbackNS: [namespaces.serverDefault, namespaces.whitelabel, namespaces.default],
                            // Explicitly set as false to allow fallback in case English / German is not set. Empty string will still be
                            // returned by the parseMissingKeyHandler down below if the key eventually is empty for every language
                            returnEmptyString: false,
                            missingKeyNoValueFallbackToKey: function missingKeyNoValueFallbackToKey() {
                                return "";
                            },
                            react: {
                                useSuspense: false,
                                transSupportBasicHtmlNodes: true
                            },
                            saveMissing: true,
                            parseMissingKeyHandler: function parseMissingKeyHandler(key) {
                                if (process.env.DEBUG) console.log("No translation found for \"" + key + "\"");
                                return "";
                            },
                            backend: {
                                backends: [(0, _i18nextResourcesToBackend2.default)(function (language, namespace, callback) {
                                    return getTranslation(whitelabel, language, namespace, callback);
                                })]
                            }
                        });

                    case 4:
                    case "end":
                        return _context2.stop();
                }
            }
        }, _callee2, undefined);
    }));

    return function initI18n(_x2) {
        return _ref3.apply(this, arguments);
    };
}();